import Vue from "vue";
import ServiceListing from "./ServiceListing.vue";

export function load() {
  const selector = "ServiceListing-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(ServiceListing, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
